<template>
  <div
    :class="{ onLockLogin: !locked }"
    class="lockscreen"
    @keyup="onLockLogin(true)"
    @mousedown.stop
    @contextmenu.prevent
  >
    <template v-if="locked">
      <div class="lock-box">
        <div class="lock">
          <span
            class="lock-icon"
            title="Unlock Screen"
            @click="onLockLogin(true)"
          >
            <NIcon
              size="40"
              color="white"
            >
              <Lock />
            </NIcon>
          </span>
        </div>
      </div>
      <DeviceRecharge
        :battery="battery"
        :battery-status="batteryStatus"
        :calc-discharging-time="calcDischargingTime"
        :calc-charging-time="calcChargingTime"
      />

      <div class="local-time">
        <div class="time">{{ hour }}:{{ minute }}</div>
        <div class="date">{{ month }}/{{ day }}/{{ year }}</div>
      </div>
      <div class="computer-status">
        <span
          :class="{ offline: !online }"
          class="network"
        >
          <Wifi />
        </span>
      </div>
    </template>
  </div>
</template>

<script>
  import { defineComponent, computed, inject } from 'vue'
  import DeviceRecharge from './device-recharge.vue'
  import { Lock, Wifi } from '@vicons/fa'
  import { NIcon } from 'naive-ui'
  import { useOnline } from '@/composables/use-online'
  import { useTime } from '@/composables/use-current-time'
  import { useBattery } from '@/composables/use-battery'
  import { useRouter } from 'vue-router'

  export default defineComponent({
    name: 'LockScreen',
    components: {
      Lock,
      Wifi,
      DeviceRecharge,
      NIcon,
    },
    setup() {
      const { month, day, hour, minute, second, year } = useTime()
      const appStoreFn = inject('appStoreFn')
      const { online } = useOnline(appStoreFn)
      const { battery, batteryStatus, calcDischargingTime, calcChargingTime } = useBattery()
      const appStore = appStoreFn()
      const locked = computed(() => appStore.screenLockState.locked)
      const router = useRouter()

      const onLockLogin = () => {
        appStore.updateScreenLock(false)
        router.go(0)
      }

      return {
        locked,
        online,
        month,
        day,
        hour,
        minute,
        second,
        year,
        battery,
        batteryStatus,
        calcDischargingTime,
        calcChargingTime,
        onLockLogin,
      }
    },
  })
</script>

<style lang="less">
  .lockscreen {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    display: flex;
    background: #000;
    color: white;
    overflow: hidden;
    z-index: 9999;

    &.onLockLogin {
      background-color: rgba(25, 28, 34, 0.88);
      backdrop-filter: blur(7px);
    }

    .login-box {
      position: absolute;
      top: 45%;
      left: 50%;
      transform: translate(-50%, -50%);
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      > * {
        margin-bottom: 14px;
      }

      .username {
        font-size: 30px;
      }
    }

    .lock-box {
      position: absolute;
      top: 20px;
      left: 50%;
      transform: translateX(-50%);
      font-size: 34px;
      z-index: 100;

      .tips {
        color: white;
        cursor: text;
      }

      .lock {
        display: flex;
        justify-content: center;

        .lock-icon {
          cursor: pointer;
          min-width: 4rem;
          min-height: 4rem;

          .anticon-unlock {
            display: none;
          }

          &:hover .anticon-unlock {
            display: initial;
          }

          &:hover .anticon-lock {
            display: none;
          }
        }
      }
    }

    .local-time {
      position: absolute;
      bottom: 60px;
      left: 60px;
      font-family: helvetica;

      .time {
        font-size: 70px;
      }

      .date {
        font-size: 40px;
      }
    }

    .computer-status {
      position: absolute;
      bottom: 60px;
      right: 60px;
      font-size: 24px;

      > * {
        margin-left: 14px;
      }

      .network {
        position: relative;

        &.offline::before {
          content: '';
          position: absolute;
          left: 50%;
          top: 50%;
          width: 2px;
          height: 28px;
          transform: translate(-50%, -50%) rotate(45deg);
          background-color: red;
          z-index: 10;
        }
      }
    }
  }
</style>
